import React from "react";
import { Redirect } from "react-router-dom";

const CHUNK_RELOAD_KEY = "chunk_reload_at";

// After a new deploy, old hashed chunks no longer exist, so lazy pages fail to load
const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message) ||
  /Failed to fetch dynamically imported module/i.test(error?.message);

// Reload once to pick up the new index.html; guard against reload loops
const reloadForNewBuild = () => {
  try {
    const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY));
    if (lastReload && Date.now() - lastReload < 10000) return false;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch (e) {}
  window.location.reload();
  return true;
};

export default class ErrorWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, reloading: false };
  }

  componentDidCatch(error, info) {
    console.log("❌", error);
    if (isChunkLoadError(error) && reloadForNewBuild()) {
      this.setState({ reloading: true });
      return;
    }
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.reloading) return null;
    if (this.state.hasError) {
      return <Redirect to="/500" />;
    }
    return this.props.children;
  }
}
